<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择"
    :popper-append-to-body="false"
  >
    <el-option
      v-if="clearable"
      :key="0"
      :label="blankLabel"
      :value="0"
    ></el-option>
    <el-option
      v-for="(k, v) in StatusMap"
      :key="v"
      :label="k"
      :value="parseInt(v)"
    ></el-option>
  </el-select>
</template>

<script>
import {
  ItemStatusMap,
  ProductStatusMap,
  WarningStatusMap,
  ApplyStatusMap,
  SupplyStatusMap,
  SupplyCategoryMap,
  DeliveryCategoryMap,
  StockProductStatusMap,
} from '@/config/global'

export default {
  props: {
    value: '',
    model: '',
    clearable: {
      type: Boolean,
      default: false,
    },
    blankLabel: {
      type: String,
      default: '全部',
    },
    filter: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    StatusMap() {
      let statusMap = {}
      switch (this.model) {
        case 'item':
          statusMap = ItemStatusMap
          break
        case 'product':
          statusMap = ProductStatusMap
          break
        case 'stockProduct':
          statusMap = StockProductStatusMap
          break
        case 'lifewarning':
          statusMap = WarningStatusMap
          break
        case 'apply':
          statusMap = ApplyStatusMap
          break
        case 'supply':
          statusMap = SupplyStatusMap
          break
        case 'supplyCategory':
          statusMap = SupplyCategoryMap
          break
        case 'supplyDelivery':
          statusMap = DeliveryCategoryMap
          break
        default:
          statusMap = ItemStatusMap
          break
      }

      if (this.filter.length > 0) {
        statusMap = Object.keys(statusMap)
          .filter((key) => !this.filter.includes(parseInt(key)))
          .reduce((object, key) => {
            return Object.assign(object, {
              [key]: statusMap[key],
            })
          }, {})
      }
      return statusMap
    },
  },

  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>